import { Skeleton } from '@solinkcorp/solink-ui';

export default function SDMSkeletonHeader() {
  return (
    <div className="flex items-center justify-between gap-2 px-[16px] pt-[16px]">
      <div className="flex items-center gap-2">
        <Skeleton className="h-[34px] w-[34px] rounded-full" />
        <Skeleton className="h-[34px] w-[250px]" />
      </div>
      <div>
        <Skeleton className="h-[34px] w-[34px] rounded-full" />
      </div>
    </div>
  );
}
